/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NaturePlantLeafIcon16Light } from './NaturePlantLeafIcon16Light';
import { NaturePlantLeafIcon16Regular } from './NaturePlantLeafIcon16Regular';
import { NaturePlantLeafIcon16Solid } from './NaturePlantLeafIcon16Solid';
import { NaturePlantLeafIcon20Light } from './NaturePlantLeafIcon20Light';
import { NaturePlantLeafIcon20Regular } from './NaturePlantLeafIcon20Regular';
import { NaturePlantLeafIcon20Solid } from './NaturePlantLeafIcon20Solid';
import { NaturePlantLeafIcon24Regular } from './NaturePlantLeafIcon24Regular';
import { NaturePlantLeafIcon24Solid } from './NaturePlantLeafIcon24Solid';
import { NaturePlantLeafIcon32Regular } from './NaturePlantLeafIcon32Regular';
import { NaturePlantLeafIcon64Regular } from './NaturePlantLeafIcon64Regular';
var sizes = {
    16: {
        light: NaturePlantLeafIcon16Light,
        regular: NaturePlantLeafIcon16Regular,
        solid: NaturePlantLeafIcon16Solid,
    },
    20: {
        light: NaturePlantLeafIcon20Light,
        regular: NaturePlantLeafIcon20Regular,
        solid: NaturePlantLeafIcon20Solid,
    },
    24: {
        regular: NaturePlantLeafIcon24Regular,
        solid: NaturePlantLeafIcon24Solid,
    },
    32: {
        regular: NaturePlantLeafIcon32Regular,
    },
    64: {
        regular: NaturePlantLeafIcon64Regular,
    },
};
export var NaturePlantLeafIcon = forwardRef('NaturePlantLeafIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
